<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 102 221.683"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
    >
        <circle
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.root}"
            @click="select('root')"
            cx="38.891"
            cy="130.288"
            r="9.984"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.six}"
            @click="select('six')"
            d="M49.248 164.064c-2.707,7.398 -3.847,15.633 -3.421,24.705 0.391,8.34 2.106,17.387 5.144,27.142 1.331,0.383 2.58,0.598 3.712,0.623 2.842,0.061 5.881,-0.813 8.831,-2.584 3.62,-16.009 3.434,-32.536 -0.56,-49.582 -4.425,0.473 -8.994,0.371 -13.706,-0.304z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.thirdLeft}"
            @click="select('thirdLeft')"
            d="M45.83 188.841c-0.435,-9.1 0.704,-17.359 3.418,-24.777 -7.066,-1.013 -14.456,-3.318 -22.169,-6.913 -3.47,6.723 -5.525,14.725 -5.037,23.029 -0.124,1.374 -0.089,2.761 0.086,4.15 7.375,0.33 15.496,1.944 23.702,4.511z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fourthLeft}"
            @click="select('fourthLeft')"
            d="M45.83 188.841c-8.206,-2.567 -16.327,-4.181 -23.702,-4.511 1.779,14.11 18.002,28.454 28.843,31.581 -3.029,-9.726 -4.743,-18.75 -5.141,-27.07z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fourthRight}"
            @click="select('fourthRight')"
            d="M66.051 187.632c0.258,8.923 -0.587,17.696 -2.537,26.318 6.905,-4.146 13.329,-13.208 15.626,-26.702 -4.269,-0.186 -8.859,-0.008 -13.089,0.384z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.thirdRight}"
            @click="select('thirdRight')"
            d="M66.051 187.632c4.23,-0.392 8.82,-0.57 13.089,-0.384 0.61,-3.582 0.929,-7.477 0.889,-11.676 -0.08,-4.532 -0.825,-8.766 -2.077,-12.632 -0.275,-0.768 -0.543,-1.524 -0.806,-2.266 -4.554,1.938 -9.285,3.169 -14.192,3.694 1.843,7.865 2.875,15.62 3.097,23.264z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fifth}"
            @click="select('fifth')"
            d="M49.248 164.064c4.712,0.675 9.281,0.777 13.706,0.304 4.907,-0.525 9.638,-1.756 14.192,-3.694 -5.257,-13.509 -16.768,-21.968 -26.815,-21.968 -8.266,0 -17.621,7.539 -23.252,18.445 7.713,3.595 15.103,5.9 22.169,6.913z"
        />
        <path
            class="fil0 str1"
            :class="{redBorder:redBorder}"
            d="M80.029 175.572c-0.384,-21.904 -16.336,-36.866 -29.698,-36.866 -13.361,0 -29.569,19.698 -28.289,41.474 -1.536,17.04 21.381,36.11 32.641,36.354 11.26,0.243 25.602,-14.194 25.346,-40.962zm-52.95 -18.421c1.073,-32.985 1.789,-63.817 2.147,-92.493m48.726 98.282c-10.605,-29.637 -11.903,-39.441 -14.165,-60.905 -2.262,-21.465 -3.162,-62.058 -13.824,-76.547 -15.063,-20.47 -23.347,-6.331 -20.737,39.17"
        />
        <circle
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.periodontitis}"
            @click="select('periodontitis')"
            cx="32.559"
            cy="13.734"
            r="9.984"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]
}
</script>
